import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useFormikContext } from 'formik';
import { DefaultTextAreaField } from '../../mui-overrides/Textarea';
import { useInsertDefaultAdornment } from '../../../hooks/useInsertDefaultAdornment';
import { IAvailableAssetTypes } from '@brickwise/asset-validation/dist/utils';

interface Props {
  disabled?: boolean;
}

const fieldName = 'investmentDetails.landRegisterMortgageDescription';
/** Hides the scrollbar for placeholder texts of textareas. */
const hideScrollbarStyles = {
  '& textarea:placeholder-shown': {
    msOverflowStyle: 'none' /* IE and Edge */,
    scrollbarWidth: 'none' /* Firefox */,
    '&::-webkit-scrollbar': {
      display: 'none' /* Chrome */,
    },
  },
};
const assetTypesWithDefault: IAvailableAssetTypes[] = ['realEstate', 'builderOwnerModel'];

export const LandRegisterMortgageDeclaration: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();
  const formik = useFormikContext();
  const adornment = useInsertDefaultAdornment(
    fieldName,
    t('dashboard.assets.addedit.investment.investmentterms.fields.landRegisterMortgageDescription.placeholder'),
  );
  const showDefaultText =
    formik.getFieldProps('location.countryCode').value === 'AUT' && assetTypesWithDefault.includes(formik.getFieldProps('type').value);
  return (
    <DefaultTextAreaField
      disabled={disabled}
      label={t('dashboard.assets.addedit.investment.investmentterms.fields.landRegisterMortgageDescription.label')}
      fieldName={fieldName}
      formik={formik}
      sx={hideScrollbarStyles}
      placeholder={
        showDefaultText ? t('dashboard.assets.addedit.investment.investmentterms.fields.landRegisterMortgageDescription.placeholder') : ''
      }
      endAdornment={showDefaultText ? adornment : ''}
    />
  );
};
